// store/providerSlice.js
import { createSlice } from '@reduxjs/toolkit';

const providerSlice = createSlice({
  name: 'provider',
  initialState: {
    instance: null,
    loading: false,
    error: null,
  },
  reducers: {
    setProvider: (state, action) => {
      state.instance = action.payload;
      state.loading = false;
      state.error = null;
    },
    setProviderLoading: (state, action) => {
      state.loading = action.payload;
    },
    setProviderError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearProvider: (state) => {
      state.instance = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setProvider,
  setProviderLoading,
  setProviderError,
  clearProvider,
} = providerSlice.actions;

// Selectors
export const selectProvider = (state) => state.provider.instance;
export const selectProviderLoading = (state) => state.provider.loading;
export const selectProviderError = (state) => state.provider.error;

export default providerSlice.reducer;